export const REASON_MAX_SHOWN_LENGTH = 200;

export const tooltipPopperProps = { disablePortal: false, style: { zIndex: 1301 } };
